import * as React from 'react';
var TableContext = /*#__PURE__*/React.createContext(null);
export default TableContext;